import { get, memoize } from 'lodash'

const makeStateSelector = (
  module: string | Array<string>,
  ReducerRecord: any
) => memoize((state: {}): {} => get(state, module, { data: ReducerRecord() }))

export default makeStateSelector
